module.exports = __webpack_public_path__ + "static/media/word_association.53939ec9.jpg";